import DualTextBlock from './DualTextBlock';

export default DualTextBlock;